import { ArrowForwardIos } from '@mui/icons-material';
import commonMessages from '@rhg/lang/messages/common';
import { Button } from '@rhg/libs/material';
import { useIntl } from 'react-intl';

const styleButtonGrow = {
    flexGrow: 1,
    textWrap: 'nowrap',
};

interface ViewDetailsButtonProps {
    showEndIcon: boolean;
    buttonVariant: 'contained' | 'outlined';
    size: 'small' | 'large';
    fullWidth?: boolean;
    onClick?: () => void;
    detailsRoute?: string;
    messageKey: keyof typeof commonMessages;
}

export function ViewDetailsButton({
    showEndIcon,
    buttonVariant,
    size,
    fullWidth,
    onClick,
    detailsRoute,
    messageKey,
}: ViewDetailsButtonProps) {
    const { formatMessage } = useIntl();

    return (
        <Button
            trackButton="ProgramViewDetails"
            endIcon={showEndIcon ? <ArrowForwardIos /> : undefined}
            variant={buttonVariant}
            color="primary"
            size={size}
            disabled={!detailsRoute}
            href={detailsRoute}
            onClick={onClick}
            sx={styleButtonGrow}
            fullWidth={fullWidth}
        >
            {formatMessage(commonMessages[messageKey])}
        </Button>
    );
}
